export enum BuilderCostingActionType {
	FETCH_FC_COSTING = 'FETCH_FC_COSTING',
	STORE_FC_COSTING = 'STORE_FC_COSTING',
	EDIT_FC_BUILDER_COSTING = 'EDIT_FC_BUILDER_COSTING',

	FETCH_FC_MATERIAL_COSTING = 'FETCH_FC_MATERIAL_COSTING',
	STORE_FC_MATERIAL_COSTING = 'STORE_FC_MATERIAL_COSTING',
	EDIT_FC_MATERIAL_COSTING = 'EDIT_FC_MATERIAL_COSTING',
	ADD_FC_MATERIAL_COSTING = 'ADD_FC_MATERIAL_COSTING',

	FETCH_FC_LUMEN_COSTING = 'FETCH_FC_LUMEN_COSTING',
	STORE_FC_LUMEN_COSTING = 'STORE_FC_LUMEN_COSTING',
	EDIT_FC_LUMEN_COSTING = 'EDIT_FC_LUMEN_COSTING',

	FETCH_CABINET_MATERIALS = 'FETCH_CABINET_MATERIALS',
	STORE_CABINET_MATERIALS = 'STORE_CABINET_MATERIALS',
	ERROR_CABINET_MATERIALS = 'ERROR_CABINET_MATERIALS',
	EDIT_CABINET_MATERIALS = 'EDIT_CABINET_MATERIALS',

	FETCH_WALL_PANEL_MATERIALS = 'FETCH_WALL_PANEL_MATERIALS',
	STORE_WALL_PANEL_MATERIALS = 'STORE_WALL_PANEL_MATERIALS',
	EDIT_WALL_PANEL_MATERIALS = 'EDIT_WALL_PANEL_MATERIALS',

	FETCH_COUNTER_TOP_MATERIALS = 'FETCH_COUNTER_TOP_MATERIALS',
	STORE_COUNTER_TOP_MATERIALS = 'STORE_COUNTER_TOP_MATERIALS',
	EDIT_COUNTER_TOP_MATERIALS = 'EDIT_COUNTER_TOP_MATERIALS',

	FETCH_WALL_TILES = 'FETCH_WALL_TILES',
	STORE_WALL_TILES = 'STORE_WALL_TILES',
	UPDATE_WALL_TILE = 'UPDATE_WALL_TILE',
	ADD_WALL_TILE = 'ADD_WALL_TILE',
	ERROR_WALL_TILES = 'ERROR_WALL_TILES',

	FETCH_LIGHTS_MATERIALS = 'FETCH_LIGHTS_MATERIALS',
	STORE_LIGHTS_MATERIALS = 'STORE_LIGHTS_MATERIALS',
	FETCH_DRIVER_MATERIALS = 'FETCH_DRIVER_MATERIALS',
	STORE_DRIVER_MATERIALS = 'STORE_DRIVER_MATERIALS',

	FETCH_ELECTRICAL_MODULES = 'FETCH_ELECTRICAL_MODULES',
	STORE_ELECTRICAL_MODULES = 'STORE_ELECTRICAL_MODULES',
	EDIT_ELECTRICAL_MODULES = 'EDIT_ELECTRICAL_MODULES',

	FETCH_ELECTRICAL_MATERIALS = 'FETCH_ELECTRICAL_MATERIALS',
	STORE_ELECTRICAL_MATERIALS = 'STORE_ELECTRICAL_MATERIALS',
	EDIT_ELECTRICAL_MATERIALS = 'EDIT_ELECTRICAL_MATERIALS',

	FETCH_PAINT_MATERIALS = 'FETCH_PAINT_MATERIALS',
	STORE_PAINT_MATERIALS = 'STORE_PAINT_MATERIALS',
	EDIT_PAINT_MATERIALS = 'EDIT_PAINT_MATERIALS',

	FETCH_MOULDING_TYPES = 'FETCH_MOULDING_TYPES',
	STORE_MOULDING_TYPES = 'STORE_MOULDING_TYPES',
	EDIT_MOULDING_TYPES = 'EDIT_MOULDING_TYPES',

	FETCH_MOULDING_PATTERNS = 'FETCH_MOULDING_PATTERNS',
	STORE_MOULDING_PATTERNS = 'STORE_MOULDING_PATTERNS',
	EDIT_MOULDING_PATTERNS = 'EDIT_MOULDING_PATTERNS',

	FETCH_SFB_MATERIALS = 'FETCH_SFB_MATERIALS',
	STORE_SFB_MATERIALS = 'STORE_SFB_MATERIALS',
	EDIT_SFB_MATERIALS = 'EDIT_SFB_MATERIALS',

	FETCH_CURTAIN_MATERIALS = 'FETCH_CURTAIN_MATERIALS',
	STORE_CURTAIN_MATERIALS = 'STORE_CURTAIN_MATERIALS',
	EDIT_CURTAIN_MATERIALS = 'EDIT_CURTAIN_MATERIALS',

	FETCH_BUILDER_CHARGE_CONFIGS = 'FETCH_BUILDER_CHARGE_CONFIGS',
	STORE_BUILDER_CHARGE_CONFIGS = 'STORE_BUILDER_CHARGE_CONFIGS',
	UPSERT_BUILDER_CHARGE_CONFIG = 'UPSERT_BUILDER_CHARGE_CONFIG'
}
